import {ChangeTabEvent} from '../opac.directive';
import {Component, Output, EventEmitter, Input, Inject} from 'ng-metadata/core';

//your imports go here
import {OpacService, StatusMsg} from '../opac.service';
import {RequestService} from '../request/request.service';
import {OPAC_TAB} from '../opac.directive';
import {DateUtils} from '../../../../../nddUtils/dateUtils.service';
import {FormBuilderEnums} from '../../../../../infra/formBuilder/formBuilder.service';
import { PrimolyticsService, beacon } from '../../../../../analytics/primolytics.service';
import {getInstitutionCode} from '../../../../../appConfig/appConfigForward';

const filter = require('lodash/filter');
const forEach = require('lodash/forEach');
const cloneDeep = require('lodash/cloneDeep');
const get = require('lodash/get');

@Component({
    selector: 'prm-request-approval',
    templateUrl: 'components/search/fullView/getit/opac/requestApproval/request-approval.html',
})


export class PrmRequestApproval {

    @Output() private changeTabEvent: EventEmitter<ChangeTabEvent> = new EventEmitter();
    @Input() private statusMessage : string;
    @Input() private header : string;
    @Input() private message : string;
    @Input() private approveRequest : string;
    @Input() private cancelRequest : string;
    private disable;

    constructor(private opacService: OpacService,
                private requestService: RequestService,
                @Inject('$state') private $state: ng.ui.IStateService,
                private primolyticsService: PrimolyticsService) {
                    this.disable = false;
    }

    get formData() {
        return this.requestService.formData;
    }

    private isDisabled() {
        return this.disable;
    }

    private getLink() : string {
        switch(this.statusMessage){
            case 'isbn_exists':
                let vid = window.appConfig.vid;
                let inst = getInstitutionCode();
                let isbn = get(this.requestService, 'formData.isbn');
                let citationType = get(this.requestService, 'formData.citationType', 'book');
                return '/discovery/openurl?institution=' + inst 
                                                + '&vid=' + vid 
                                                + '&rft.isbn=' + isbn 
                                                + '&rfr_id=info:sid/primo.exlibrisgroup.com:primo4-' + citationType + '-cLinker';
            default:
                return undefined;
        }
    }

    private getLinkLabel() : string {
        switch(this.statusMessage){
            case 'isbn_exists':
                return 'almaPurchaseRequest.approveRequest.link';
            default:
                return undefined;
        }
    }

    public cancel() {
        this.changeTabEvent.emit(null); // null = Go to last tab
    }

    // --------------------------------------------------------------------------------
    // ----------------                 REQUEST COMMIT        -------------------------
    // --------------------------------------------------------------------------------
    
    public commit() {
        this.disable = true;
        let service = this.requestService.service;
        let postData = cloneDeep(this.formData);

        if (!postData.group_id) { //set it as ILS API ID
            postData.group_id = this.requestService.ilsApiId;
        }

        if (postData.item_id) { //special case - request by item level
            /* update API to item level */
            service['link-to-service'] = service['link-to-service'] + '/item/' + postData.item_id;
        }
        let itemId = postData.item_id || postData.itemId;
        this.manipulatePostData(postData);
        let mmsId = itemId ? undefined : postData.group_id;

        postData.copyright = 'Y';
        
        this.opacService.makeIlsCall(service, postData, 'POST')
            .then((res) => {
                this.disable = false;
                this.opacService.responseStatus = new StatusMsg(res.status === 'ok', res['reply-text']);
                let eventData = {
                    dest: OPAC_TAB.RESPONSE,
                    itemId: itemId,
                    mmsId: mmsId
                };
                this.changeTabEvent.emit(eventData);

            });
    }

    private manipulatePostData(postData) {
        forEach(postData, (value, key) => {
            let field = this.getFieldByName(this.requestService.form, key);
            if (field) {
                if (field.fieldType === FormBuilderEnums.FIELD_TYPE.INTERNAL) {
                    delete postData[key];
                    return;
                }
                if (field.uiType === FormBuilderEnums.UI_TYPE.DATE) {
                    let dateUtils = new DateUtils();
                    postData[key] = dateUtils.convertDateTypeToIlsDateString(postData[key]);
                }
            }
        });
    }

    private getFieldByName(form, name) {
        let matchedFields = filter(form, (el) => { return el.name === name; });
        return matchedFields[0];
    }

    // --------------------------------------------------------------------------------
    // ----------------                 BEACONS               -------------------------
    // --------------------------------------------------------------------------------

    
    private sendLinkClickBeacon() : void {
        switch(this.statusMessage){
            case 'isbn_exists':
                this.sendResourceExistBeacon();
                break;
        }
    }

    @beacon({'p':'general', 'op':'resourceExistLink'})
    private sendResourceExistBeacon(){}

}


// WEBPACK FOOTER //
// ./src/main/webapp/components/search/fullView/getit/opac/requestApproval/requestApproval.directive.ts